<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <p class="copyright">© 2024 {{ siteName }} 版权所有</p>
        <p class="slogan">动漫爱好者的资料宝库</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState(['siteName'])
  }
}
</script>

<style scoped>
.footer {
  background-color: #2c2c2c;
  border-top: 3px solid #e60012;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 25px 20px;
}

.footer-content {
  text-align: center;
  color: #999;
}

.copyright {
  font-size: 14px;
  margin-bottom: 8px;
}

.slogan {
  font-size: 13px;
  color: #777;
}

/* ============ 移动端适配 ============ */
@media (max-width: 768px) {
  .footer {
    border-top-width: 2px;
  }
  
  .footer-container {
    padding: 20px 16px;
  }
  
  .copyright {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .slogan {
    font-size: 12px;
  }
}

/* ============ 小屏手机适配 (≤375px) ============ */
@media (max-width: 375px) {
  .footer-container {
    padding: 16px 12px;
  }
  
  .copyright {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  .slogan {
    font-size: 11px;
  }
}
</style>